<template>
  <div class="contact_container">
    <el-image :src="toppic" class="mb-10 bs-10 br-10 db" style="height: 335px;"></el-image>
    <el-row class="mb-10">
      <el-col :span="24" style="height: 400px;">
        <el-image :src="contact_info" class="bs-10 br-10 db" style="height: 400px;"></el-image>
        <div class="view_map" @click="initMap"></div>
      </el-col>
    </el-row>

    <el-row ref="map_container" class="map_container mb-10" v-bind:class="{showmap:mapVisible}">
      <el-col :span="24">
        <div ref="bdmap" class="bdmap mb-10 bs-10 br-10"></div>
      </el-col>
    </el-row>
    <div class="message_wrap mb-10 bs-10 br-10">
      <el-row>
        <el-col :span="12" :offset="6">
          <div class="title-en">MESSAGE</div>
          <div class="title"></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" :offset="4">
          <span class="my-label">Name:</span>
          <div class="my-input">
            <el-input v-model="form.name"></el-input>
          </div>
          <span class="star">*require</span>
        </el-col>
        <el-col :span="8">
          <span class="my-label">Phone:</span>
          <div class="my-input">
            <el-input v-model="form.phone"></el-input>
          </div>
          <span class="star">*require</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" :offset="4">
          <span class="my-label">E-mail:</span>
          <div class="my-input">
            <el-input v-model="form.email"></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <span class="my-label">Topic:</span>
          <div class="my-input">
            <el-input v-model="form.qq"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4" style="display: flex;">
          <span class="my-label">Message:</span>
          <div class="my-input" style="width: calc(100% - 140px);margin-left: 4px;margin-bottom: 20px;">
            <el-input type="textarea" :rows="3" v-model="form.content"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" :offset="6" style="text-align: center; margin-bottom: 20px;">
          <el-button type="primary" style="width: 120px;" @click="postMessage">Submit</el-button>
        </el-col>
      </el-row>
    </div>
    <!--
    <div class="contact_info_wrap">
      <div class="contact_info_container">
        <el-row style="height: 50%;">
          <el-col :span="12" class="bg tal">
            <div>
              <p>联系电话</p>
              <p>0592-6663516</p>
              <p>(工作日:8:30-17:30)</p>
              <p>(节假日:9:00-11:00)</p>
            </div>
          </el-col>
          <el-col :span="12" class="bg tar">
            <div>
              <p class="fs-48 c1">联系我们</p>
              <p class="c1">生活因您的来电而美</p>
              <p class="fs-48 c2">CONTACT US</p>
            </div>
          </el-col>
        </el-row>
        <el-row style="height: 50%;">
          <el-col :span="12" class="bg tal">
            <div style="position: absolute;left:0;bottom: 0;">
              <p>厦门谊瑞智能制造有限公司</p>
              <p>地址:厦门市集美区杏北二路66号</p>
            </div>
          </el-col>
          <el-col :span="12" class="bg tar">
            <div  style="position: absolute;right:0;bottom: 0;">
              <el-button>查看地图</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    -->
    <div class="h-30"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        toppic: require('@/assets/contact-0.jpg'),
        contact_info: require('@/assets/contact-1.jpg'),
        form: {
          name: '',
          phone: '',
          email: '',
          qq: '',
          content: '',
        },
        mapVisible: false
      }
    },
    methods:{
      postMessage(){
        if(this.form.name.trim() == ''){
          this.$message({
          	message: 'Name can not be empty！',
          	type: 'error',
          });
          return;
        }
        this.$axios.post('/api/message', {
            name: this.form.name,
            phone: this.form.phone,
            email: this.form.email,
            qq: this.form.qq,
            content: this.form.content
          })
          .then(res=> {
            console.log(res);
            this.$message({
            	message: res.data.msg,
            	type: 'success',
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      initMap(){
        this.mapVisible = true;
        var map = new BMapGL.Map(this.$refs.bdmap);
        map.centerAndZoom(new BMapGL.Point(118.048844, 24.586368), 17);
        map.enableScrollWheelZoom(true);
        // 创建点标记
        var marker1 = new BMapGL.Marker(new BMapGL.Point(118.048844, 24.586368));
        //var marker2 = new BMapGL.Marker(new BMapGL.Point(118.042834, 24.584281));

        // 在地图上添加点标记
        map.addOverlay(marker1);
      }
    }
  }
</script>

<style scoped>
  .contact_container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .contact_container .image {
    /*height: 1015px;*/
  }

  .bg {
    /* background-color: #409EFF; */
    height: 100%;
    position: relative;
  }

  .tal {
    text-align: left;
  }

  .tar {
    text-align: right;
  }

  .fs-48 {
    font-size: 48px;
    font-weight: bold;
  }

  .c1 {
    color: #FFF;
  }

  .c2 {
    color: #3D3CFA;
    font-family: "microsoft yahei";
    font-weight: bold;
  }

  .h-30 {
    height: 50px;
  }

  .contact_info_wrap {
    max-width: 1200px;
    height: 470px;
    /*   padding-left: 220px;
    padding-right: 220px; */
    padding: 95px 220px 75px;
    border: 1px solid #00ffff;
    box-sizing: border-box;
  }

  .contact_info_container {
    /* margin: 95px 220px 75px; */
    width: 100%;
    height: 100%;
    background-color: #409EFF;
  }
  .message_wrap {
      max-width: 1200px;
      margin: 0 auto;
      background: #fff;
    }

    .message_wrap .el-row .el-col {
      text-align: left;
    }

    .message_wrap .my-input {
      display: inline-block;
      width: calc(100% - 140px);
      margin-bottom: 10px;
    }

    .message_wrap .my-label {
      display: inline-block;
      width: 80px;

    }

    .message_wrap .title-en {
      font-family: ABold;
      font-size: 54px;
      color: #b09f89;
      opacity: .2;
      text-align: center;
    }

    .message_wrap .title {
      width: 200px;
      height: 30px;
      margin-left: auto;
      margin-right: auto;
      padding-bottom: 8px;
      margin-bottom: 30px;
      border-bottom: 1px solid #b09f89;
      text-align: center;
      position: relative;
      top: -40px;
    }

    .message_wrap .star {
      color: #cdb86d;
      font-size: 12px;
      width: 40px;
    }

    .bdmap {
      overflow: hidden;
      /* width: 1200px; */
      height: 400px;
      margin: 0 auto;
      font-family: "微软雅黑";
    }
    .map_container {
      display: none;
    }
    .showmap {
      display: block;
    }

    .view_map {
       width: 130px;
       height: 25px;
       position: absolute;
       left: 845px;
       top: 308px;
       cursor: pointer;
    }
    @media screen and (max-width: 1080px) {
      .view_map{
          display: none;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue